export const isBooking = type  => type === 'booking';